import { GenericDialog } from '../../GenericDialog';
import { abyssColors } from '@/theme/colors';
import { Button, Stack, Typography } from '@mui/material';

export const InvalidScopeDialog = ({
  open,
  setOpen,
  handleCancel,
  handleContinue,
  loading,
}: {
  open: boolean;
  setOpen: (open: boolean) => void;
  handleCancel: () => void;
  handleContinue: () => void;
  loading: boolean;
}) => {
  return (
    <GenericDialog
      open={open}
      dialogStyles={{
        '.MuiDialog-container': {
          alignItems: 'baseline',
          paddingTop: '14.8rem',
        },
      }}
      paperStyles={{
        maxWidth: '47.2rem',
      }}
      titleStyles={{
        padding: '2.4rem',
        paddingBottom: '1.6rem',
        typography: 'h4',
      }}
      onClose={() => setOpen(false)}
      title="No POI attached"
      contentStyles={{
        padding: '0 2.4rem',
        paddingBottom: '4.3rem',
      }}
      content={
        <Typography variant="h6" fontWeight={400} color="primary" letterSpacing={0}>
          You are generating a report without linking any POIs to the relevant component(s). To
          attach POIs, mark them as CVI or GVI.
        </Typography>
      }
      actions={
        <Stack gap="1.2rem" direction="row" sx={{}}>
          <Button onClick={handleCancel}>Cancel</Button>
          <Button
            variant="contained"
            sx={{ fontWeight: 500 }}
            onClick={handleContinue}
            disabled={loading}
          >
            Generate anyway
          </Button>
        </Stack>
      }
      actionsStyles={{
        padding: '1.6rem 2.4rem',
        borderTop: `0.1rem solid ${abyssColors.primary[100]}`,
      }}
    />
  );
};
